import { render, staticRenderFns } from "./ApiYoutube.vue?vue&type=template&id=1c0bc627&"
import script from "./ApiYoutube.vue?vue&type=script&lang=js&"
export * from "./ApiYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports